<template>
    <router-view />
</template>

<script lang="ts" setup>
import { useAuthStore } from '@core/stores/auth';

const authStore = useAuthStore();
authStore.getAuthorizedUser();

</script>

<style>
@import '@core/assets/index.css';

</style>
